import { render, staticRenderFns } from "./OrderUserDetailForm.vue?vue&type=template&id=35493894&"
import script from "./OrderUserDetailForm.vue?vue&type=script&lang=js&"
export * from "./OrderUserDetailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports